import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';
// @mui
import { alpha, ThemeProvider, createTheme, useTheme } from '@mui/material/styles';
// hooks
import useSettings from '../../hooks/useSettings';
//
import componentsOverride from '../../theme/overrides';

// ----------------------------------------------------------------------

ThemeColorPresets.propTypes = {
  children: PropTypes.node,
};

export default function ThemeColorPresets({ children }) {
  const defaultTheme = useTheme();

  const { setColor } = useSettings();

  const themeOptions = useMemo(
    () => ({
      ...defaultTheme,
      palette: {
        ...defaultTheme.palette,
        primary: setColor,
      },
      customShadows: {
        ...defaultTheme.customShadows,
        primary: `0 8px 16px 0 ${alpha(setColor.main, 0.24)}`,
      },
    }),
    [setColor, defaultTheme]
  );

  const theme = createTheme(themeOptions);

  const {
    lighter,
    light,
    dark,
    gradient1,
    gradient2,
    gradient3,
    gradient4,
    gradient5,
    gradient6,
    gradientIOS1,
    gradientIOS2,
    gradientIOS3,
    gradientIOS4,
    gradientIOS5,
    gradientIOS6, 
  } = theme.palette.primary;

  const dynamicGradient = `linear-gradient(227.6deg, ${lighter} 2.08%, ${light} 50%, ${dark} 97.92%)`;
  const dynamicGradient2 = `linear-gradient(180deg, ${lighter} 0%, ${light} 50%, ${dark} 97.92%)`;
  const dynamicGradient3 = `linear-gradient(180deg, #CFFF9B 0%, rgba(207,255,155,0) 100%)`;
  const dynamicGradient3Ios = dynamicGradient3;
                            
  // Override gradient inside palette
  if (theme.palette.gradients) {
    theme.palette.gradients.theme = dynamicGradient;
    theme.palette.gradients.theme2 = dynamicGradient2;
    theme.palette.gradients.theme3 = dynamicGradient3;
    theme.palette.gradients.theme3Ios = dynamicGradient3Ios;
  }

  // Override all places using static GRADIENTS.theme
  if (theme.palette.header?.register_btn) {
    theme.palette.header.register_btn.bg = dynamicGradient;
  }

  if (theme.palette.visitor?.login) {
    theme.palette.visitor.login.buttonBg = dynamicGradient;
  }

  if (theme.palette.visitor?.register) {
    theme.palette.visitor.register.buttonBg = dynamicGradient;
  }

  if (theme.palette.transactionDialog?.deposit) {
    theme.palette.transactionDialog.deposit.confirmBtn = dynamicGradient;
  }

  theme.components = componentsOverride(theme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
